//bootstrap css
import 'bootstrap/dist/css/bootstrap.min.css'
//fonts
import '@mdi/font/css/materialdesignicons.css'

import { createApp } from 'vue'
import * as Sentry from '@sentry/vue'
import App from './App.vue'
import router from './router'
import config from './config'
import './services/check-version'
import storageService from './services/storage'

const app = createApp(App)

Sentry.init({
  app,
  dsn: 'https://e5afee07c32b4904417e38d192cc2db7@o92284.ingest.us.sentry.io/4508591069462528',
  integrations: [],
  environment: config.environment,
  release: config.release,
  attachStacktrace: true
})

import('@sentry/vue').then((lazyLoadedSentry) => {
  Sentry.addIntegration(
    lazyLoadedSentry.httpClientIntegration({
      failedRequestTargets: [
        new RegExp(`^${config.apiBaseUrl.replace(/[-/\\^$*+?.()|[\]{}]/g, '\\$&')}(\\/.*)?$`)
      ]
    })
  )
  Sentry.addIntegration(lazyLoadedSentry.browserTracingIntegration({ router }))
})

app.use(router)

router.beforeEach((to, from, next) => {
  if (storageService.isSignedIn()) {
    next()
  } else if (to.path === '/login') {
    next()
  } else {
    next('/login')
  }
})

app.mount('#app')
